import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createCertificationMaster } from "../../../actions/admin/certification/certification_master_action";

const CertficationMasterModel = (props) => {
  const dispatch = useDispatch();

  const [master, setCertificationMaster] = useState({
    type: props.type,
    name: "",
    description: "",
    overview: "",
  });
  const state = useSelector((state) => state.certificationMasterReducer);
  const [show, setShow] = useState(props.show);
  const handleClose = () => {
    setShow(false);
    props.handelUpdateShow(false);
  };

  const handleMasterSubmit = () => {
    //e.preventDefault();
    dispatch(createCertificationMaster(master));
  };

  if (state.is_done && show) {
    setShow(false);
    props.handelUpdateShow(false);
  }
  return (
    <div>
      <Modal
        className="custom-modal"
        show={show}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add {props.title} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="err-model-body">
          <form>
            <div className={"row"}>
              <div className={"col-lg-12 mb-12"}>
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    {" "}
                    {props.title} Name
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={master.name}
                    onChange={(e) =>
                      setCertificationMaster({
                        ...master,
                        name: e.target.value,
                      })
                    }
                  />
                  <span className="error-msg">
                    {state.errors.name ? state.errors.name : ""}
                    {state.errors.type ?  "The Name has already been taken.": ""}
                  </span>
                </div>
              </div>
              {master && master.type === "Exam" && (
                <div className="col-lg-12 mb-12">
                  <div className="form-group">
                    <label className="mont-font fw-600 font-xsss">
                      {"Exam Overview "}
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      value={master.overview}
                      onChange={(e) =>
                        setCertificationMaster({
                          ...master,
                          overview: e.target.value,
                        })
                      }
                    />
                    <span className="error-msg">
                      {state.errors.overview ? state.errors.overview : ""}
                    </span>
                  </div>
                </div>
              )}

              {master && master.type === "Exam" && (
                <div className="col-lg-12 mb-12">
                  <div className="form-group">
                    <label className="mont-font fw-600 font-xsss">
                      {" "}
                      Description
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      value={master.description}
                      onChange={(e) =>
                        setCertificationMaster({
                          ...master,
                          description: e.target.value,
                        })
                      }
                    />
                    <span className="error-msg">
                      {state.errors.description ? state.errors.description : ""}
                    </span>
                  </div>
                </div>
              )}

              {master && master.type === "RolesType" && (
                <div className="col-lg-12 mb-12">
                  <div className="form-group">
                    <label className="mont-font fw-600 font-xsss">
                      {" "}
                      Description
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      value={master.description}
                      onChange={(e) =>
                        setCertificationMaster({
                          ...master,
                          description: e.target.value,
                        })
                      }
                    />
                    <span className="error-msg">
                      {state.errors.description ? state.errors.description : ""}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className={"row"}>
              <div className="col-lg-12 text-right">
                <input
                  type="button"
                  name="submit"
                  value="Submit"
                  onClick={() => handleMasterSubmit()}
                  className="btn-common px-5 mt-15"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CertficationMasterModel;
